
import { MatTableDataSource } from '@angular/material/table';
import { CommentsModel } from '../Models/commentsModel';
import { CommentDataModel } from '../Models/commentDataModel';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';



@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.css']
})

export class WarningDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public dialogRef: MatDialogRef<WarningDialogComponent>) {}

  ngOnInit() {
    const mockResponse = this.data.data;
    console.log(mockResponse); // Use mockResponse data as needed
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  // commentsList: CommentsModel[] = [];
  //  extractedData: CommentsModel[] = [];
 
  

  // constructor(@Inject(MAT_DIALOG_DATA) public data: { comments: CommentsModel[] }) {}

  // ngOnInit(): void {
  //   if (this.data && this.data.comments) {
  //     this.commentsList = this.data.comments;
  //     const arr=this.commentsList['data'];
      
  //     console.log('Dialog data: 07', this.commentsList['data']);
  //     for (const item of arr) {
  //       const EmployeeId = item.employeeID;
  //       const CommentsData = item.CommentsData;
  //       this.extractedData.push({ EmployeeId, CommentsData });
  //     }
      
  //     // Now extractedData contains objects with employeeId and commentsDataModel
  //     console.log('extractedData');
  //     console.log(this.extractedData);

  //   }
   

   
  //   console.log('Dialog data: 07 len', this.commentsList.length);

  //   console.log('Dialog data:', this.commentsList[0].EmployeeId);

    
    
    
    
  //   // this.commentsList[0].CommentsData[0].Differdates;
    
  // }


}
